import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Wizard, Steps, Step, WithWizard } from 'react-albus-react18';
import { Helmet } from 'react-helmet';
import { gsap } from 'gsap';
import axios from 'axios';
import Reveal from 'react-awesome-reveal';
import { keyframes } from '@emotion/react';
import MyButton from './components/UI/button/MyButton';
import Signup from './pages/Signup/Signup';
import Trial from './pages/Trial/Trial';
import Bundle from './pages/Bundle/Bundle';
import Graph from './pages/Graph/Graph';
import Website from './pages/Website/Website';
import Term from './pages/Term';
import Privacy from './pages/Privacy';
import { useHistory, useLocation } from 'react-router-dom';
import WelcomeToZeely from './pages/WelcomeToZeely/WelcomeToZeely';
import Signup2 from './pages/Signup/Signup2';
import CheckEmail from './components/CheckEmail/CheckEmail';
import BackHistory from './components/BackHistory/BackHistory';
import TermPage from './pages/TermPage';
import PrivacyPage from './pages/PrivacyPage';
import mixpanel from 'mixpanel-browser';
import useOverflow from './hooks/useOverflow';
import useBlockClassName from './hooks/useBlockClassName';
import Welcome1 from './pages/Welcome/Welcome1';
import Header from './components/Header/Header';
import WebsiteLoader from './pages/WebsiteLoader/WebsiteLoader';
import CheckDetails from './pages/CheckDetails/CheckDetails';
import AIAnalyzer from './pages/AIAnalyzer/AIAnalyzer';
import { useDispatch, useSelector } from 'react-redux';
import { setIsShowPrivacy, setIsShowTerm } from './store/termSlice';
import BusinessArea from './pages/BusinessArea';
import Name from './pages/Name/Name';
import WebsiteLoaderImg from './pages/WebsiteLoader/components/WebsiteLoaderImg/WebsiteLoaderImg';
import AiAnalyzerImg from './pages/AIAnalyzer/components/AiAnalyzerImg/AiAnalyzerImg';
import CompanyName from './pages/CompanyName/CompanyName';
import Email from './pages/Email/Email';
import Home from './pages/Home/Home';
import Stage from './pages/Stage/Stage';
import Products from './pages/Products/Products';
import Featured from './pages/Featured/Featured';
import VideoQuiz from './pages/VideoQuiz/VideoQuiz';
import StageContent from './pages/Stage/StageContent';
import ProductsContent from './pages/Products/ProductsContent';
import VideosContent from './pages/VideoQuiz/VideosContent';
import Avatars from './pages/Avatars/Avatars';
import AvatarsContent from './pages/Avatars/AvatarsContent';
import VideoTemplate from './pages/VideoTemplate/VideoTemplate';
import VideoTemplateContent from './pages/VideoTemplate/VideoTemplateContent';
import CreativeQuiz from './pages/CreativeQuiz/CreativeQuiz';
import Creatives from './pages/Creatives/Creatives';
import CreativeQuizContent from './pages/CreativeQuiz/CreativeQuizContent';
import { setButtonClick } from './store/buttonSlice';
import SmartAi from './pages/SmartAi/SmartAi';
import Channels from './pages/Channels/Channels';
import ChannelsContent from './pages/Channels/ChannelsContent';
import SmartAiContent from './pages/SmartAi/SmartAiContent';
import { setButtonClickNot } from './store/buttonNotSlice';
import MyButtonWhite from './components/UI/button/MyButtonWhite';
import Platfroms from './pages/Platforms/Platfroms';
import PlatfromsContent from './pages/Platforms/PlatformsContent';
import Goals from './pages/Goals/Goals';
import GoalsContent from './pages/Goals/GoalsContent';
import Current from './pages/Current/Current';
import Target from './pages/Target/Target';
import Reach from './pages/Reach/Reach';
import Reviews from './pages/Reviews/Reviews';
import Predict from './pages/Predict/Predict';
import Plan from './pages/Plan/Plan';
import FeaturedContent from './pages/Featured/FeaturedContent';
import CreativesContent from './pages/Creatives/CreativesContent';
import ReviewsContent from './pages/Reviews/ReviewsContent';
import FinalOffer from './pages/FinalOffer/FinalOffer';
import FinalPlan from './pages/Plan/FinalPlan';
import ConfirmEmail from './pages/ConfirmEmail/ConfirmEmail';
import MyInput from './components/UI/input/MyInput';
import AIAnalyzerContent from './pages/AIAnalyzer/AIAnalyzerContent';
// import ReactPixel from 'react-facebook-pixel';
import TopGoal from './pages/TopGoal/TopGoal';
import Productivity from './pages/Productivity/Productivity';
import VideoToBlob from './components/VideoToBlob/VideoToBlob';
import Home1 from './pages/HomeNewPages/Home1/Home1';
import Home5 from './pages/HomeNewPages/Home5/Home5';
import VideoQuote from './pages/Featured/VideoQuote';
import ProofTemplate from './pages/ProofTemplate/ProofTemplate';
import ProofTemplateContent from './pages/ProofTemplate/ProofTemplateContent';
import Case from './pages/Case/Case';
import CaseContent from './pages/Case/CaseContent';
import BeforeAfter from './pages/BeforeAfter/BeforeAfter';
import BeforeAfterContent from './pages/BeforeAfter/BeforeAfterContent';
import Replace from './pages/Replace/Replace';
import AiSetup from './pages/AiSetup/AiSetup';
import PlanNew from './pages/Plan/PlanNew';
import ReplaceContent from './pages/Replace/ReplaceContent';
import AiSetupContent from './pages/AiSetup/AiSetupContent';

function App({ isStart }) {
    const { overflow, changeOverflow } = useOverflow();
    const { blockClassName } = useBlockClassName();
    const isShowTerm = useSelector((state) => state.term.isShowTerm);
    const isShowPrivacy = useSelector((state) => state.term.isShowPrivacy);
    const buttonShow = useSelector((state) => state.button.isShow);
    const buttonText = useSelector((state) => state.button.text);
    const buttonIcon = useSelector((state) => state.button.icon);
    const buttonError = useSelector((state) => state.button.error);
    const buttonNotShow = useSelector((state) => state.buttonNot.isShow);
    const buttonNotText = useSelector((state) => state.buttonNot.text);
    const buttonNotIcon = useSelector((state) => state.buttonNot.icon);

    const dispatch = useDispatch();

    function setSessionIdLocalStorage(sessionId) {
        localStorage.setItem('session_id', sessionId);
    }

    function getSessionIdFromLocalStorage() {
        return localStorage.getItem('session_id');
    }

    function generateSessionId() {
        return Math.random().toString(36).substring(2);
    }

    const sessionId = getSessionIdFromLocalStorage() || generateSessionId();
    setSessionIdLocalStorage(sessionId);


    useEffect(() => {
        if (window.fbq) return;

        window.fbq = function () {
            window.fbq.callMethod
                ? window.fbq.callMethod.apply(window.fbq, arguments)
                : window.fbq.queue.push(arguments);
        };

        window.fbq.queue = [];
        window.fbq.loaded = true;
        window.fbq.version = '2.0';

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);

        script.onload = () => {
            window.fbq('init', '507395697701950');
        };
    }, [])


    useEffect(() => {
        // const advancedMatching = { em: 'support@zeely.app' };
        // const options = {
        //     autoConfig: true,
        //     debug: false
        // };

        // ReactPixel.init('', {}, options);

        mixpanel.init('e777f1e7a8a69795e4b701389d9859a7', {
            ignore_dnt: true,
            debug: true,
            track_pageview: false,
            persistence: 'localStorage'
        });
        mixpanel.identify(sessionId);

        const isFirstSession = !localStorage.getItem('mixpanel_first_session');

        if (isFirstSession) {
            const userAgent = navigator.userAgent;
            const deviceType = detectDeviceType(userAgent);

            const installationDate = new Date();

            const formattedInstallationDate = formatDate(installationDate);

            localStorage.setItem('installation_date', formattedInstallationDate);

            mixpanel.track('SESSION_STARTED', {
                session_id: sessionId,
                // device_type: deviceType,
                session_start: formattedInstallationDate,
                // installation_source: window.location.hostname,
                web_utm_campaign: localStorage.getItem('utmCampaign'),
                web_utm_source: localStorage.getItem('utmSource'),
                web_utm_medium: localStorage.getItem('utmMedium'),
                web_utm_content: localStorage.getItem('utmContent'),
                web_utm_term: localStorage.getItem('utmTerm'),
                isDebug: false,
                funnel: 'MAIN_v1'
            });

            localStorage.setItem('mixpanel_first_session', 'true');
        }
    }, []);

    const formatDate = (date) => {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${month}.${day}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const detectDeviceType = (userAgent) => {
        if (/Android/i.test(userAgent)) {
            return 'Android';
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            return 'iOS';
        } else if (/Windows Phone/i.test(userAgent)) {
            return 'Windows Phone';
        } else if (/Windows/i.test(userAgent)) {
            return 'Windows';
        } else if (/Macintosh|Mac OS/i.test(userAgent)) {
            return 'Macintosh';
        } else if (/Linux/i.test(userAgent)) {
            return 'Linux';
        } else {
            return 'Unknown';
        }
    };

    function saveUTMToLocalStorage() {
        const queryParams = new URLSearchParams(window.location.search);
        const utmSource = queryParams.get('utm_source');
        const utmMedium = queryParams.get('utm_medium');
        const utmCampaign = queryParams.get('utm_campaign');
        const utmContent = queryParams.get('utm_content');
        const utmTerm = queryParams.get('utm_term');

        if (utmSource) localStorage.setItem('utmSource', utmSource);
        if (utmMedium) localStorage.setItem('utmMedium', utmMedium);
        if (utmCampaign) localStorage.setItem('utmCampaign', utmCampaign);
        if (utmContent) localStorage.setItem('utmContent', utmContent);
        if (utmTerm) localStorage.setItem('utmTerm', utmTerm);
    }

    useEffect(() => {
        saveUTMToLocalStorage();
    }, []);

    const history = useHistory();

    const customAnimation = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `;

    const [buttonTime, setButtonTime] = useState(0);
    const [creativeType, setCreativeType] = useState('');
    const [buttonStatus, setButtonStatus] = useState('');
    const [aiShow, setAiShow] = useState(false);
    const [homeShow, sethomeShow] = useState(false);
    const [handShow, setHandShow] = useState(false);
    const [blockStyle, setBlockStyle] = useState({});
    const [welcometoShow, setWelcometo] = useState(false);
    const [WelcomeWrapper, setWelcomeWrapper] = useState(false);

    const [timeLeft, setTimeLeft] = useState(30);
    const [isChecked, setIsChecked] = useState(true);
    const [showTerm, setShowTerm] = useState(false);
    const [showTermBundle, setShowTermBundle] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showBlock, setShowBlock] = useState(true);
    const [signupBottom, setSignupBottom] = useState('');
    const [priceBottomShow, setPriceBottomShow] = useState(false);

    const [muteStatus, setMuteStatus] = useState(true);

    const [blockHeight, setBlockHeight] = useState('auto');
    const [blockPaddingBottom, setBlockPaddingBottom] = useState('0rem');
    const [whiteWrapper, setWhiteWrapper] = useState(false);
    const blockHeightRef = useRef(null);

    const [checkboxes, setCheckboxes] = useState({
        Facebook: true
    });
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState('1');

    const [caseStatus, setCaseStatus] = useState(true);
    const [caseName, setCaseName] = useState('case1');

    const [eventProperties, setEventProperties] = useState([]);
    const [eventName, setEventName] = useState([]);

    const [platfrom, setPlatfrom] = useState('');

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes('android')) {
            setPlatfrom('Android');
        } else if (
            userAgent.includes('iphone') ||
            userAgent.includes('ipad') ||
            userAgent.includes('ipod')
        ) {
            setPlatfrom('iOS');
        } else {
            setPlatfrom('');
        }
    }, []);

    const queryParams = new URLSearchParams(window.location.search);
    const fbcid = queryParams.get('fbcid');

    const stepsMain = [
        // {
        //     id: '',
        //     component: <Home5 isStart={isStart} />,
        //     // <Home isStart={isStart} />
        //     preload: <StageContent />
        // },
        { id: '', component: <Stage fbcid={fbcid} />, preload: <FeaturedContent /> },
        {
            id: 'helped',
            component: <Featured />,
            preload: <ProductsContent />
        },
        { id: 'products', component: <Products />, preload: '' },
        {
            id: 'video-quote',
            component: <VideoQuote id={'0'} />,
            preload: <ProofTemplateContent img="video-proof.webp" />
        },
        {
            id: 'video-proof',
            component: (
                <ProofTemplate
                    eventName="onboarding_video_proof"
                    title="AI videos boost sales by 4x thanks to quick production and effective A/B testing"
                    text="*Based on the latest marketing trends"
                    img="video-proof.webp"
                />
            ),
            preload: <CaseContent id={'0'} />
        },
        {
            id: 'video-usecase',
            component: <Case id={'0'} />,
            preload: <BeforeAfterContent id={'0'} />
        },
        { id: 'video-reason', component: <BeforeAfter id={'0'} />, preload: <VideosContent /> },
        {
            id: 'video-ads',
            component: <VideoQuiz />,
            preload: (
                <>
                    <AvatarsContent />
                </>
            )
        },
        {
            id: 'video-avatars',
            component: <Avatars />,
            preload: <VideoTemplateContent img={'Dynamic templates.webp'} />
        },
        {
            id: 'video-templates',
            component: (
                <VideoTemplate
                    eventName={'onboarding_video_templates'}
                    id={'video-templates'}
                    queryName={'video-templates'}
                    video={'Dynamic templates.mp4'}
                    img={'Dynamic templates.webp'}
                    title={'Add dynamic templates?'}
                    text={
                        'Create diverse high-quality video ads with rich transitions and performance-focused elements'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Conversion_Scripts.webp'} />
        },
        {
            id: 'video-scripts',
            component: (
                <VideoTemplate
                    eventName={'onboarding_video_scripts'}
                    id={'video-scripts'}
                    queryName={'video-scripts'}
                    img={'Conversion_Scripts.webp'}
                    video={'Conversion_Scripts.mp4'}
                    title={'Add sales-focused scripts?'}
                    text={
                        'Let AI craft your scripts using proven frameworks like AIDA, PAS, Before-After-Bridge, 4U, and FAB'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Hooks_&_CTAs.webp'} />
        },
        {
            id: 'video-hooks',
            component: (
                <VideoTemplate
                    eventName={'onboarding_video_hooks'}
                    id={'video-hooks'}
                    queryName={'video-hooks'}
                    img={'Hooks_&_CTAs.webp'}
                    video={'Hooks_&_CTAs.mp4'}
                    title={'Add custom hooks & CTAs?'}
                    text={
                        'Grab attention and drive sales with top hooks and call-to-actions that grow CTR and maximize results'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Conversion-focused_cursor.webp'} />
        },
        {
            id: 'video-conversion',
            component: (
                <VideoTemplate
                    eventName={'onboarding_video_conversion'}
                    id={'video-conversion'}
                    queryName={'video-conversion'}
                    img={'Conversion-focused_cursor.webp'}
                    video={'Conversion-focused_cursor.mp4'}
                    title={'Add conversion widget?'}
                    text={
                        'Create AI video ads with high CTR, low cost per click, increased purchases, and outstanding ROAS'
                    }
                />
            ),
            preload: ''
        },

        {
            id: 'static-quote',
            component: <VideoQuote id={'1'} />,
            preload: <ProofTemplateContent img="static-proof.webp" />
        },
        {
            id: 'static-proof',
            component: (
                <ProofTemplate
                    eventName={'onboarding_static_proof'}
                    title="See how mixing<br>video and static ads can boost your revenue"
                    text="* This data is based on results from our users"
                    img="static-proof.webp"
                />
            ),
            preload: <CaseContent id={'1'} />
        },

        {
            id: 'static-usecase',
            component: <Case id={'1'} />,
            preload: <BeforeAfterContent id={'1'} />
        },
        {
            id: 'static-reason',
            component: <BeforeAfter id={'1'} />,
            preload: <CreativeQuizContent />
        },
        {
            id: 'static-ads',
            component: <CreativeQuiz />,
            preload: <VideoTemplateContent img={'100+ proven templates.webp'} />
        },
        {
            id: 'static-templates',
            component: (
                <VideoTemplate
                    eventName={'onboarding_static_templates'}
                    id={'static-templates'}
                    queryName={'static-templates'}
                    img={'100+ proven templates.webp'}
                    title={'Add 100+ tested templates?'}
                    video={'100+ proven templates.mp4'}
                    text={
                        'Access over 100 AI-picked, high-selling templates, updated regularly to boost sales and drive results'
                    }
                />
            ),
            preload: <CreativesContent content="4" />
        },
        {
            id: 'static-examples',
            component: <Creatives />,
            preload: <VideoTemplateContent img={'AI-Powered_Content.webp'} />
        },
        {
            id: 'static-text',
            component: (
                <VideoTemplate
                    eventName={'onboarding_static_text'}
                    id={'static-text'}
                    queryName={'static-text'}
                    video={'AI-Powered_Content.mp4'}
                    img={'AI-Powered_Content.webp'}
                    title={'Add AI text tools?'}
                    text={
                        'Let AI generate engaging headlines, CTAs, and other ad copy — all optimized for best performance'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Drag_n_Drop_Editing.webp'} />
        },
        {
            id: 'static-editor',
            component: (
                <VideoTemplate
                    eventName={'onboarding_static_editor'}
                    id={'static-editor'}
                    queryName={'static-editor'}
                    img={'Drag_n_Drop_Editing.webp'}
                    video={'Drag_n_Drop_Editing.mp4'}
                    title={'Add drag-and-drop editor?'}
                    text={
                        'Customize your creatives easily — no design skills or experience needed with our smart AI tools'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Bulk_Ad_Creation.webp'} />
        },
        {
            id: 'static-bulk',
            component: (
                <VideoTemplate
                    eventName={'onboarding_static_bulk'}
                    id={'static-bulk'}
                    queryName={'static-bulk'}
                    img={'Bulk_Ad_Creation.webp'}
                    video={'Bulk_Ad_Creation.mp4'}
                    title={'Add bulk creation?'}
                    text={
                        'Generate multiple ads at once, perfect for A/B testing  and maximizing performance'
                    }
                />
            ),
            preload: ''
        },

        {
            id: 'ad-quote',
            component: <VideoQuote id={'2'} />,
            preload: <ProofTemplateContent img="ad-proof.webp" />
        },

        {
            id: 'ad-proof',
            component: (
                <ProofTemplate
                    eventName={'onboarding_ad_proof'}
                    title="See how AI performance marketing can grow your sales and revenue"
                    text="* Based on the latest marketing trends"
                    img="ad-proof.webp"
                />
            ),
            preload: <CaseContent id={'2'} />
        },

        {
            id: 'ad-usecase',
            component: <Case id={'2'} />,
            preload: <BeforeAfterContent id={'2'} />
        },
        {
            id: 'ad-reason',
            component: <BeforeAfter id={'2'} />,
            preload: <SmartAiContent img={'Smart_AI_Campaigns 1.webp'} />
        },
        {
            id: 'ad-campaigns',
            component: (
                <SmartAi
                    id={'ad-campaigns'}
                    title={'Would you like to have smart<br> ad campaigns run by AI?'}
                    video={'Smart_AI_Campaigns 1.mp4'}
                    img={'Smart_AI_Campaigns 1.webp'}
                    text={'AI handles creatives, texts, and campaign setup'}
                />
            ),
            preload: <ChannelsContent />
        },
        {
            id: 'ad-channels',
            component: <Channels />,
            preload: <VideoTemplateContent img={'AI_Audience_Targeting.webp'} />
        },
        {
            id: 'ad-targeting',
            component: (
                <VideoTemplate
                    eventName={'onboarding_ad_targeting'}
                    id={'ad-targeting'}
                    queryName={'ad-targeting'}
                    img={'AI_Audience_Targeting.webp'}
                    title={'Add smart AI targeting?'}
                    video={'AI_Audience_Targeting.mp4'}
                    text={
                        'Discover untapped audiences ready to buy your product with the help of AI'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'AI_Ads_Optimisations.webp'} />
        },
        {
            id: 'ad-optimization',
            component: (
                <VideoTemplate
                    eventName={'onboarding_ad_optimization'}
                    id={'ad-optimization'}
                    queryName={'ad-optimization'}
                    img={'AI_Ads_Optimisations.webp'}
                    title={'Add AI-optimized ads?'}
                    video={'AI_Ads_Optimisations.mp4'}
                    text={
                        'Let AI monitor, adjust, and scale your campaigns 24/7 for higher ROAS and steady performance growth'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'Real-time_ad_reports.webp'} />
        },
        {
            id: 'ad-reports',
            component: (
                <VideoTemplate
                    eventName={'onboarding_ad_reports'}
                    id={'ad-reports'}
                    queryName={'ad-reports'}
                    img={'Real-time_ad_reports.webp'}
                    video={'Real-time_ad_reports.mp4'}
                    title={'Add real-time reporting?'}
                    text={
                        'Get personalized AI-driven insights in one tap to make data-driven decisions for campaign success'
                    }
                />
            ),
            preload: <VideoTemplateContent img={'AI_copilot 1.webp'} />
        },
        {
            id: 'ad-copilot',
            component: (
                <VideoTemplate
                    eventName={'onboarding_ad_copilot'}
                    id={'ad-copilot'}
                    queryName={'ad-copilot'}
                    img={'AI_copilot 1.webp'}
                    video={'AI_copilot.mp4'}
                    title={'Add AI copilot for your ads?'}
                    text={
                        'Have AI run your ad account, crunch numbers, and set up your ads to boost your Meta standing'
                    }
                />
            ),
            preload: <PlatfromsContent />
        },
        { id: 'ad-platform', component: <Platfroms />, preload: '' },
        { id: 'top-goal', component: <TopGoal />, preload: <GoalsContent /> },
        { id: 'ad-goals', component: <Goals />, preload: '' },
        { id: 'ad-current', component: <Current />, preload: '' },
        { id: 'ad-target', component: <Target />, preload: '' },
        { id: 'ad-timeline', component: <Reach />, preload: <ReviewsContent /> },
        { id: 'productivity-goals', component: <Productivity />, preload: '' },
        { id: 'productivity-current', component: <Current productivity={true} />, preload: '' },
        { id: 'productivity-target', component: <Target productivity={true} />, preload: '' },
        {
            id: 'productivity-timeline',
            component: <Reach productivity={true} />,
            preload: <ReviewsContent />
        },
        { id: 'reviews', component: <Reviews />, preload: '' },
        { id: 'hello', component: <Name />, preload: '' },
        {
            id: 'signup',
            component: <Email />,
            preload: <img src={process.env.PUBLIC_URL + `/img/Graph-line.svg`} alt="" />
        },
        {
            id: 'name',
            component: <Predict isStart={isStart} />,
            preload: <CaseContent id={'3'} />
        },
        { id: 'summary-proof', component: <Case id={'3'} />, preload: <ReplaceContent /> },
        { id: 'replace', component: <Replace />, preload: <AiSetupContent /> },
        { id: 'features', component: <AiSetup />, preload: '' },
        { id: 'plan', component: <PlanNew isStart={isStart} />, preload: '' },
        { id: 'trial', component: <Trial />, preload: '' },
        { id: 'final-offer', component: <FinalOffer />, preload: '' },
        { id: 'final-plan', component: <FinalPlan />, preload: '' },
        { id: 'welcome', component: <WelcomeToZeely />, preload: '' },
        { id: 'confirm-email', component: <ConfirmEmail />, preload: '' },
        { id: 'password', component: <Signup />, preload: '' },
        {
            id: 'product-link',
            component: <Website />,
            preload: (
                <>
                    <WebsiteLoaderImg />
                    <img src={process.env.PUBLIC_URL + '/img/i1.jpg'} alt="" />
                    <img src={process.env.PUBLIC_URL + '/img/i2.jpg'} alt="" />
                    <img src={process.env.PUBLIC_URL + '/img/i3.jpg'} alt="" />
                </>
            )
        },
        { id: 'product-loader', component: <WebsiteLoader />, preload: '' },
        { id: 'industry', component: <BusinessArea />, preload: <MyInput /> },
        {
            id: 'industry-save',
            component: <BusinessArea save={true} />,
            preload: ''
        },
        { id: 'company-name', component: <CompanyName />, preload: <AIAnalyzerContent /> },
        {
            id: 'company-name-save',
            component: <CompanyName save={true} />,
            preload: ''
        },
        {
            id: 'product-check',
            component: <CheckDetails />,
            preload: <AiAnalyzerImg />
        },
        {
            id: 'ai-loader',
            component: <AIAnalyzer />,
            preload: (
                <>
                    <AIAnalyzerContent />
                    <img src={process.env.PUBLIC_URL + '/img/welcome/download_app.webp'} alt="" />
                    <img
                        src={process.env.PUBLIC_URL + '/img/welcome/welcome1-android.jpg'}
                        alt=""
                    />
                    <img src={process.env.PUBLIC_URL + '/img/welcome/welcome1-apple.jpg'} alt="" />
                </>
            )
        },
        {
            id: 'loader',
            component: <AIAnalyzer showIndustry={true} />,
            preload: (
                <>
                    <img src={process.env.PUBLIC_URL + '/img/welcome/download_app.webp'} alt="" />
                    <img
                        src={process.env.PUBLIC_URL + '/img/welcome/welcome1-android.jpg'}
                        alt=""
                    />
                    <img src={process.env.PUBLIC_URL + '/img/welcome/welcome1-apple.jpg'} alt="" />
                </>
            )
        },
        {
            id: 'booster',
            component: <Bundle />,
            preload: (
                <img
                    src={process.env.PUBLIC_URL + '/img/graph.svg'}
                    style={{ width: '100%' }}
                    alt=""
                />
            )
        },
        { id: 'booster-prediction', component: <Graph />, preload: '' },
        {
            id: 'thankyou',
            component: (
                <Welcome1
                    platfrom={platfrom}
                    setEventName={setEventName}
                    setEventProperties={setEventProperties}
                    sessionId={sessionId}
                    // setButtonShow={setButtonShow}
                    setButtonStatus={setButtonStatus}
                    BrandName={false}
                    WebSite={false}
                    setWelcomeWrapper={setWelcomeWrapper}
                    setBlockPaddingBottom={setBlockPaddingBottom}
                    setWhiteWrapper={setWhiteWrapper}
                />
            ),
            preload: ''
        },
        // { id: 'signup2', component: SignupElement2, preload: '' },
        {
            id: 'term',
            component: (
                <TermPage
                    setWhiteWrapper={setWhiteWrapper}
                    setShowBlock={setShowBlock}
                    //  setButtonShow={setButtonShow}
                    setShowTerm={setShowTerm}
                />
            ),
            preload: ''
        },
        {
            id: 'privacy',
            component: (
                <PrivacyPage
                    setWhiteWrapper={setWhiteWrapper}
                    setShowBlock={setShowBlock}
                    //  setButtonShow={setButtonShow}
                    setShowPrivacy={setShowPrivacy}
                />
            ),
            preload: ''
        }
    ];

    const privacyChange = () => {
        setShowBlock(false);
        // setButtonShow(false)
        setShowPrivacy(true);
        setBlockPaddingBottom('0');
    };

    const termBundleClose = () => {
        dispatch(setIsShowTerm(false));
    };

    const privacyBundleClose = () => {
        dispatch(setIsShowPrivacy(false));
    };

    const handleClick = () => {
        dispatch(setButtonClick(true));
    };

    const handleClickNot = () => {
        dispatch(setButtonClickNot(true));
    };

    const sendAlert = async (path, data, errorLog) => {
        const now = new Date();
        const utcString = now.toISOString();

        const formdata = new FormData();
        formdata.append('domain', window.location.hostname);
        formdata.append('time', utcString);
        formdata.append('email', localStorage.getItem('email'));
        formdata.append('path', path);
        formdata.append('data', data);
        formdata.append('error', errorLog);
        console.log(formdata);
        try {
            const response = await axios.post('https://zee.sale/send-alert.php', formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleForget = () => {
        setButtonStatus('EnterEmail');
    };

    useEffect(() => {
        if (timeLeft > 0) {
            const timerId = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearTimeout(timerId);
        }
    }, [timeLeft]);

    useEffect(() => {
        const setVHVariable = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setVHVariable();
        window.addEventListener('resize', setVHVariable);
        return () => window.removeEventListener('resize', setVHVariable);
    }, []);

    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                dispatch(setIsShowTerm(false));
                dispatch(setIsShowPrivacy(false));
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <Router>
                <Route
                    render={({ history }) => (
                        <Wizard
                            initialStep=""
                            history={history}
                            render={({ step, steps }) => (
                                <div
                                    className={`wrapper ${aiShow ? 'block-ai' : ''} ${
                                        homeShow ? 'block-home' : ''
                                    } ${whiteWrapper ? 'block-white' : ''} ${
                                        WelcomeWrapper ? 'block-welcome' : ''
                                    } ${blockClassName}`}>
                                    <Helmet>
                                        <meta name="theme-color" content="#fff"></meta>
                                    </Helmet>
                                    <>
                                        <WithWizard
                                            render={({ next, previous, step, steps }) => (
                                                <>
                                                    <BackHistory
                                                        sessionId={sessionId}
                                                        step={step}
                                                        steps={steps}
                                                        nextFunction={next}
                                                    />
                                                    <VideoToBlob steps={steps} step={step} />
                                                </>
                                            )}
                                        />
                                        <Header step={step} steps={steps} />
                                    </>

                                    {steps.indexOf(step) >
                                        steps.findIndex((step) => step.id === 'signup') && (
                                        <CheckEmail />
                                    )}

                                    <div
                                        className="block"
                                        style={{
                                            paddingBottom: blockPaddingBottom
                                            // overflow
                                        }}>
                                        <Steps>
                                            {stepsMain.map((stepMain) => (
                                                <Step key={stepMain.id} id={stepMain.id}>
                                                    <>
                                                        <div className="preload">
                                                            {steps.indexOf(step) + 4 <
                                                            stepsMain.length ? (
                                                                <>
                                                                    {
                                                                        stepsMain[
                                                                            steps.indexOf(step)
                                                                        ]?.preload
                                                                    }
                                                                    {/* {
                                                                        stepsMain[
                                                                            steps.indexOf(step) + 1
                                                                        ]?.preload
                                                                    }
                                                                    {
                                                                        stepsMain[
                                                                            steps.indexOf(step) + 2
                                                                        ]?.preload
                                                                    }
                                                                    {
                                                                        stepsMain[
                                                                            steps.indexOf(step) + 3
                                                                        ]?.preload
                                                                    }
                                                                    {
                                                                        stepsMain[
                                                                            steps.indexOf(step) + 4
                                                                        ]?.preload
                                                                    } */}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {stepsMain[0].preload}
                                                                    {/* {stepsMain[1].preload}
                                                                    {stepsMain[2].preload}
                                                                    {stepsMain[3].preload}
                                                                    {stepsMain[4].preload} */}
                                                                </>
                                                            )}
                                                        </div>

                                                        {!welcometoShow && (
                                                            <>
                                                                <Reveal
                                                                    style={{
                                                                        ...blockStyle,
                                                                        display: showBlock
                                                                            ? 'block'
                                                                            : 'none'
                                                                    }}
                                                                    cascade
                                                                    keyframes={customAnimation}>
                                                                    {stepMain.component}
                                                                </Reveal>
                                                            </>
                                                        )}
                                                    </>
                                                </Step>
                                            ))}
                                        </Steps>

                                        {welcometoShow && (
                                            <Steps>
                                                {stepsMain.map((stepMain) => (
                                                    <Step key={stepMain.id} id={stepMain.id}>
                                                        <div className="preload">
                                                            {stepMain.preload}
                                                        </div>
                                                        {stepMain.component}
                                                    </Step>
                                                ))}
                                            </Steps>
                                        )}

                                        {buttonShow && (
                                            <div className="block-button">
                                                <WithWizard
                                                    render={({ next, previous, step, steps }) => (
                                                        <>
                                                            {buttonNotShow && (
                                                                <MyButtonWhite
                                                                    style={{ marginBottom: '8rem' }}
                                                                    buttonText={buttonNotText}
                                                                    buttonIcon={buttonNotIcon}
                                                                    onClick={() => handleClickNot()}
                                                                />
                                                            )}

                                                            <MyButton
                                                                buttonStatus={buttonStatus}
                                                                buttonTime={buttonTime}
                                                                buttonText={buttonText}
                                                                buttonIcon={buttonIcon}
                                                                onClick={() => handleClick()}
                                                                className={`${
                                                                    buttonError ? 'error' : ''
                                                                }`}></MyButton>

                                                            {handShow && (
                                                                <div className="hand">
                                                                    <svg
                                                                        width="55"
                                                                        height="55"
                                                                        viewBox="0 0 55 55"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_11035_53290)">
                                                                            <path
                                                                                d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04Z"
                                                                                fill="white"></path>
                                                                            <path
                                                                                d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04ZM16.573 16.2051C17.1738 15.8582 17.9337 16.0618 18.2805 16.6626L25.1555 28.5705L27.3206 27.3205L24.8206 22.9903C24.4737 22.3895 24.6773 21.6297 25.2781 21.2828C25.8789 20.9359 26.6388 21.1395 26.9857 21.7403L29.4857 26.0705L31.6507 24.8205L29.1507 20.4903C28.8038 19.8895 29.0074 19.1297 29.6083 18.7828C30.2091 18.4359 30.9689 18.6395 31.3158 19.2403L33.8158 23.5705L36.0826 22.2617L34.8326 20.0967C34.4857 19.4958 34.6893 18.736 35.2901 18.3891C35.8899 18.0429 36.6508 18.2458 36.9977 18.8467L41.8808 27.3045C44.0458 31.0544 42.7999 35.704 39.049 37.8696L37.1892 38.9433C35.6033 39.859 33.9059 40.0841 32.2744 39.8857L18.5124 36.2842C17.7525 36.0806 17.4494 35.5556 17.653 34.7957C17.8577 34.0353 18.3817 33.7328 19.1415 33.9364L26.5061 35.9097L16.1155 17.9126C15.7686 17.3118 15.9722 16.552 16.573 16.2051Z"
                                                                                fill="black"></path>
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_11035_53290">
                                                                                <rect
                                                                                    width="40"
                                                                                    height="40"
                                                                                    fill="white"
                                                                                    transform="translate(0 20) rotate(-30)"></rect>
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {isShowPrivacy && (
                                        <div className="brandname">
                                            <div className="brandname-wrapper" ref={wrapperRef}>
                                                <div
                                                    className="term-back"
                                                    onClick={privacyBundleClose}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="46"
                                                        height="46"
                                                        viewBox="0 0 46 46"
                                                        fill="none">
                                                        <path
                                                            d="M25.75 17L20.25 22.8182L25.75 29"
                                                            stroke="black"
                                                            stroke-width="1.6"
                                                            stroke-linecap="round"
                                                        />
                                                    </svg>
                                                </div>
                                                <Privacy />
                                            </div>
                                        </div>
                                    )}

                                    {isShowTerm && (
                                        <div className="brandname">
                                            <div className="brandname-wrapper" ref={wrapperRef}>
                                                <div
                                                    className="term-back"
                                                    onClick={termBundleClose}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="46"
                                                        height="46"
                                                        viewBox="0 0 46 46"
                                                        fill="none">
                                                        <path
                                                            d="M25.75 17L20.25 22.8182L25.75 29"
                                                            stroke="black"
                                                            stroke-width="1.6"
                                                            stroke-linecap="round"
                                                        />
                                                    </svg>
                                                </div>
                                                <Term />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    )}
                />
            </Router>
        </>
    );
}

export default App;
